module.exports = __webpack_public_path__ + "static/media/2.bb335811.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/detail/ngk/2.png
// module id = 667
// module chunks = 0